// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html[dir="rtl"] .b1642d {
  transform: rotateY(180deg);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-icons/dist/esm/icons/IconWrapper.css"],"names":[],"mappings":"AAAA;EAEU,0BAA0B;AACpC","sourcesContent":["html[dir=\"rtl\"] .b1642d {\n  -webkit-transform: rotateY(180deg);\n          transform: rotateY(180deg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
